import React, { useState } from 'react';

import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';
import PropTypes from 'prop-types';

import { DebInstallerEmailPopup } from 'components/DebFormComponents/Popup/DebInstallerEmailPopup';
import { DebInstallerPhonePopup } from 'components/DebFormComponents/Popup/DebInstallerPhonePopup';
import { FormSection } from 'components/FormHelper/FormSection';
import { InputField } from 'components/FormHelper/InputField';
import { InputRow } from 'components/FormHelper/InputRow';
import { TooltipIconButton } from 'components/TooltipIconButton/TooltipIconButton';

import { isFachinteressent } from 'utils/InstallerUtils';

export const InstallerContactSection = ({ formik, initialValues, onSaved }) => {
  const [phonePopupOpen, setPhonePopupOpen] = useState(false);
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const { installer } = useCurrentInstaller();
  const [savedValues, setSavedValues] = useState({
    phone: initialValues.phone,
    mobile: initialValues.mobile,
    email: initialValues.email,
  });

  return (
    <>
      <FormSection
        subtitle={
          isFachinteressent(installer)
            ? 'Kontaktdaten'
            : 'Kontaktdaten - diese Daten werden im mein.Auftragsportal (mAP) angezeigt'
        }
        tooltip="Die Veröffentlichung dieser Daten erfolgt nur, wenn Sie der Adressveröffentlichung zugestimmt haben.">
        <InputRow>
          <InputField
            label="Telefon"
            name="phone"
            fullWidth
            oldValue={savedValues.phone}
            variant="standard"
            disabled
            value={formik.values.phone || ''}
            error={Boolean(formik.errors.phone)}
            helperText={formik.errors.phone || ''}
          />
          <InputField
            label="Mobil"
            name="mobile"
            fullWidth
            oldValue={savedValues.mobile}
            variant="standard"
            disabled
            value={formik.values.mobile || ''}
            error={Boolean(formik.errors.mobile)}
            infoText="Entweder Mobil und/oder Telefonnummer angeben"
            helperText={formik.errors.mobile || ''}
          />
          <div className="input-row__action">
            <TooltipIconButton
              className="expert-table__icon-button"
              aria-label="Telefonnummern bearbeiten"
              onClick={() => setPhonePopupOpen(true)}>
              <EditIcon />
            </TooltipIconButton>
          </div>
        </InputRow>
      </FormSection>

      <FormSection>
        <InputRow>
          <InputField
            label="E-Mail-Adresse"
            name="email"
            fullWidth
            oldValue={savedValues.email}
            variant="standard"
            disabled
            value={formik.values.email || ''}
            infoText={
              !isFachinteressent(installer)
                ? 'Mit der Änderung der E-Mail-Adresse, ändern Sie die Zugangsdaten zum mAP und e-fix.'
                : 'Mit der Änderung der E-Mail-Adresse, ändern Sie die Zugangsdaten zum e-fix.'
            }
            helperText=""
          />
          <div className="input-row__action">
            <TooltipIconButton
              className="expert-table__icon-button"
              aria-label="E-Mail-Adresse bearbeiten"
              onClick={() => setEmailPopupOpen(true)}>
              <EditIcon />
            </TooltipIconButton>
          </div>
        </InputRow>
      </FormSection>

      {phonePopupOpen && (
        <DebInstallerPhonePopup
          mainFormik={formik}
          popupOpen={phonePopupOpen}
          setPopupOpen={setPhonePopupOpen}
          onSaved={(vals) => {
            setSavedValues((prev) => ({ ...prev, ...vals }));
            onSaved?.(vals);
          }}
        />
      )}
      {emailPopupOpen && (
        <DebInstallerEmailPopup
          mainFormik={formik}
          popupOpen={emailPopupOpen}
          setPopupOpen={setEmailPopupOpen}
          onSaved={(vals) => {
            setSavedValues((prev) => ({ ...prev, ...vals }));
            onSaved?.(vals);
          }}
        />
      )}
    </>
  );
};

InstallerContactSection.displayName = 'InstallerContactSection';

InstallerContactSection.propTypes = {
  formik: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  onSaved: PropTypes.func,
};

InstallerContactSection.defaultProps = {
  onSaved: undefined,
};
